import React from 'react';
import { CollectionView } from 'common';
import { classes, style } from 'typestyle';
import { ADALONG_COLORS } from '@src/styles';

interface Props {
  type?: CollectionView['type'];
  manualLabel: string;
  autoLabel: string;
}

export function CollectionTypeBadge({ type, manualLabel, autoLabel }: Props) {
  const isManualCollection = type === 'manual';
  const collectionTypeLabel = isManualCollection ? manualLabel : autoLabel;

  return (
    <div
      className={classes(
        collectionTypeBadgeClass,
        isManualCollection ? manualCollectionTypeBadgeClass : autoCollectionTypeBadgeClass
      )}
    >
      {collectionTypeLabel}
    </div>
  );
}

const collectionTypeBadgeClass = style({
  position: 'absolute',
  top: '15%',
  right: -1,
  transform: 'translateY(-50%)',
  padding: '3px 14px 3px 18px',
  fontSize: 9,
  fontWeight: 700,
  letterSpacing: 0.6,
  borderTopLeftRadius: 16,
  borderBottomLeftRadius: 16,
  textTransform: 'uppercase',
  pointerEvents: 'none',
  boxShadow: '0 4px 10px rgba(0,0,0,0.35)',
});

const autoCollectionTypeBadgeClass = style({
  background: ADALONG_COLORS.FLASH_BLUE,
  color: ADALONG_COLORS.LIGHT_WHITE,
});

const manualCollectionTypeBadgeClass = style({
  background: ADALONG_COLORS.DARK_GRAY,
  color: ADALONG_COLORS.LIGHT_WHITE,
});
